var UserProfileQueryParam = /* @__PURE__ */ ((UserProfileQueryParam2) => {
  UserProfileQueryParam2["UserIdHash"] = "user_profile_uid";
  UserProfileQueryParam2["Tab"] = "user_profile_tab";
  UserProfileQueryParam2["ContractDigiconIdHash"] = "user_profile_contract_did";
  UserProfileQueryParam2["Action"] = "user_profile_action";
  return UserProfileQueryParam2;
})(UserProfileQueryParam || {});
var UserProfileTabSlug = /* @__PURE__ */ ((UserProfileTabSlug2) => {
  UserProfileTabSlug2["Information"] = "information";
  UserProfileTabSlug2["Document"] = "document";
  UserProfileTabSlug2["HrNote"] = "hr-note";
  UserProfileTabSlug2["Contract"] = "contract";
  UserProfileTabSlug2["Goal"] = "goal";
  UserProfileTabSlug2["Review"] = "review";
  UserProfileTabSlug2["Evaluation"] = "evaluation";
  UserProfileTabSlug2["Salary"] = "salary";
  UserProfileTabSlug2["Growth"] = "growth";
  UserProfileTabSlug2["Training"] = "training";
  UserProfileTabSlug2["GroupInsurance"] = "group-insurance";
  return UserProfileTabSlug2;
})(UserProfileTabSlug || {});

export { UserProfileQueryParam, UserProfileTabSlug };
//# sourceMappingURL=types.mjs.map
